import React from 'react';
import { Link } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { serviceCategories } from '../mock';
import { useLang } from '../i18n/LanguageContext';
import { useAsset } from '../assets/AssetsContext';

const ServiceCard = ({ cat }) => {
  const { t } = useLang();
  const firstTreatment = cat.treatments[0];
  const img = useAsset(`cat.${cat.id}`, cat.image);
  return (
    <Link
      to={`/treatments/${firstTreatment.slug}`}
      className="group relative block rounded-[28px] overflow-hidden aspect-[4/5] card-hover"
    >
      <div
        className="absolute inset-0"
        style={{
          background:
            'linear-gradient(180deg, #0B3D2E 0%, #124D3A 30%, #1B6A50 45%, #D4AF37 58%, #F6E3A1 100%)',
        }}
      />
      <div className="absolute top-0 inset-x-0 h-1/2 bg-gradient-to-b from-[#0B3D2E]/60 to-transparent pointer-events-none" />

      <h3 className="absolute top-7 left-0 right-0 text-center z-20 font-serif-display text-[30px] md:text-[34px] text-white tracking-tight">
        {t(`cat.${cat.id}`, cat.label)}
      </h3>

      <div
        className="absolute left-1/2 -translate-x-1/2 w-[120%] aspect-square rounded-full pointer-events-none"
        style={{
          background:
            'radial-gradient(ellipse at 50% 30%, #F6E3A1 0%, #D4AF37 55%, #C49B2C 80%, transparent 100%)',
          bottom: '-30%',
        }}
      />

      <img
        src={img}
        alt={cat.label}
        loading="lazy"
        className="absolute inset-x-0 bottom-0 w-full h-[82%] object-cover object-[center_top] z-10 transition-transform duration-700 group-hover:scale-105"
      />

      <div className="absolute inset-x-0 top-0 h-[38%] bg-gradient-to-b from-[#0B3D2E] via-[#0B3D2E]/40 to-transparent z-10 pointer-events-none" />

      <div className="absolute bottom-6 left-6 right-6 z-20">
        <div className="w-full py-3 px-6 text-center bg-[#0B3D2E]/40 backdrop-blur-md border border-white/30 rounded-full text-white text-sm font-medium group-hover:bg-[#D4AF37] group-hover:border-[#D4AF37] group-hover:text-[#0B3D2E] transition-all">
          {t('ce.checkTreatments', 'Check Treatments')}
        </div>
      </div>
    </Link>
  );
};

const CommittedExcellence = () => {
  const { t } = useLang();
  return (
    <section id="services" className="py-16 sm:py-24 md:py-32 bg-[#f5ede2] text-[#0B3D2E] relative">
      <div className="max-w-[1280px] mx-auto px-5 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="font-serif-display text-3xl sm:text-4xl md:text-6xl leading-tight mb-3 inline-flex items-center gap-3 sm:gap-4 flex-wrap justify-center">
            <span>{t('ce.title')}</span>
            <span
              className="w-10 h-10 sm:w-14 sm:h-14 rounded-full flex items-center justify-center"
              style={{ background: 'linear-gradient(135deg, #F6E3A1 0%, #D4AF37 50%, #A8832E 100%)' }}
            >
              <Sparkles className="w-5 h-5 sm:w-6 sm:h-6 text-white" />
            </span>
            <span className="peach-text italic">{t('ce.title.italic')}</span>
          </h2>
          <p className="text-[#0B3D2E]/70 text-base sm:text-lg">{t('ce.sub')}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
          {serviceCategories.map((cat) => (
            <ServiceCard key={cat.id} cat={cat} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default CommittedExcellence;
